import type { Request } from "express";

import type { IKazooIdToken } from "./IKazooIdToken";

export type KazooRequest = Pick<
  Request,
  "query" | "headers" | "ip" | "url" | "hostname" | "method"
> & {
  t: any;
  features: {
    [key: string]: boolean;
  };
  user?: any;
  requestId?: string;
  idToken?: IKazooIdToken;
};
